module.exports = __webpack_public_path__ + "static/media/ic_password_pengguna.37a00feb.svg";